import React from "react";

const EventDescriptionInput = ({ description, onChange }) => (
  <div>
    <label className="block font-medium text-gray-700 mb-1">Event Description</label>
    <textarea
      placeholder="Enter event details. Provide as much detail as possible..."
      value={description}
      onChange={(e) => onChange("eventDescription", e.target.value)}
      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      rows={4}
    />
  </div>
);

export default EventDescriptionInput;
